import { useEffect } from 'react';
import './PlayMenuSheet.css';

export interface PlayMenuItem {
  key: string;
  title: string;
  desc: string;
  icon: React.ReactNode;
  accent: string;
  onClick: () => void;
  badge?: 'dot' | 'new' | null;
}

interface Props {
  open: boolean;
  title: string;
  closeLabel: string;
  items: PlayMenuItem[];
  variant: 'fun' | 'ranked' | 'shop' | 'leaderboard';
  onClose: () => void;
}

export function PlayMenuSheet({ open, title, closeLabel, items, variant, onClose }: Props) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className={`play-menu-sheet play-menu-sheet--${variant}`} role="dialog" aria-modal="true" onClick={onClose}>
      <div className="play-menu-card" onClick={e => e.stopPropagation()}>
        <button type="button" className="play-menu-close" onClick={onClose} aria-label={closeLabel}>×</button>
        <h2 className="play-menu-title">{title}</h2>
        <div className="play-menu-list">
          {items.map(it => (
            <button
              key={it.key}
              type="button"
              className="play-menu-item"
              style={{ ['--accent' as any]: it.accent }}
              onClick={() => { it.onClick(); onClose(); }}
            >
              <span className="play-menu-item-icon" aria-hidden="true">{it.icon}</span>
              <span className="play-menu-item-text">
                <span className="play-menu-item-title">{it.title}</span>
                <span className="play-menu-item-desc">{it.desc}</span>
              </span>
              {it.badge === 'dot' && <span className="play-menu-item-dot" aria-hidden="true" />}
              {it.badge === 'new' && <span className="play-menu-item-new">NEW</span>}
              <span className="play-menu-item-arr" aria-hidden="true">→</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
